export class LdmValue {
  static capInput(raw: string, max: number): string {
    const trimmed = raw.trim();
    if (!trimmed) return "";
    const n = Number.parseFloat(trimmed);
    if (!Number.isFinite(n)) return "";
    if (n > max) return String(max);
    return raw;
  }
}
